// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".formOrganization-list{max-height:200px;overflow-y:scroll;transition:height ease-in-out 1s;cursor:pointer}.organizationForm_closeBtn{width:40px}", ""]);
// Exports
module.exports = exports;
